import request from '@/libs/request'

// 牛场饲料库存 列表
export function cattleFodderListApi (data) {
  return request({
    url: `cattleFarm/cattleFodder`,
    method: 'get',
    params: data
  })
}

// 牛场饲料库存 详情
export function cattleFodderDetailApi (id) {
  return request({
    url: `cattleFarm/cattleFodder/` + id,
    method: 'get'
  })
}


// 牛场饲料库存 编辑/添加
export function cattleFodderSaveApi (data) {
  return request({
    url: `cattleFarm/cattleFodder`,
    method: 'post',
    data: data
  })
}

// 牛场饲料库存 删除
export function cattleFodderDelApi (id) {
  return request({
    url: `cattleFarm/cattleFodder/` + id,
    method: 'delete'
  })
}

//牛场饲料 所有数据
export function cattleFodderAllApi (data = {}) {
  return request({
    url: `cattleFarm/cattleFodderApi/all`,
    method: 'get',
    params: data
  })
}


